import { DateTime } from 'luxon';

import { type SupportedLocale } from '@watershed/intl/constants';
import { formatDateRange } from '@watershed/intl/formatters';
import {
  DateString,
  relayDateStringToJsDateNullable,
  relayDateStringToJsDateTimeNullable,
} from '@watershed/shared-frontend/relay/scalars';

export function getDateRangeAsDateTimes({
  start,
  end,
}: {
  start: DateString | null | undefined;
  end: DateString | null | undefined;
}): { startDate: DateTime | null; endDate: DateTime | null } {
  return {
    startDate: relayDateStringToJsDateTimeNullable(start),
    endDate: relayDateStringToJsDateTimeNullable(end),
  };
}

export function getRelayDateRangeAsDates({
  start,
  end,
}: {
  start: DateString | null | undefined;
  end: DateString | null | undefined;
}): { startDate: Date | null; endDate: Date | null } {
  return {
    startDate: relayDateStringToJsDateNullable(start),
    endDate: relayDateStringToJsDateNullable(end),
  };
}

/**
 * Formats date range with variable inputs of possibly null or undefined strings.
 */
export function formatNullableDateRangeRelay({
  locale,
  start,
  end,
}: {
  locale: SupportedLocale;
  start: DateString | null | undefined;
  end: DateString | null | undefined;
}): string | null {
  const { startDate, endDate } = getRelayDateRangeAsDates({ start, end });

  // Splitting up for typecheck of overloads
  if (startDate && endDate) {
    return formatDateRange(startDate, endDate, {
      locale,
      year: 'numeric',
      month: 'short',
    });
  }

  if (startDate) {
    return formatDateRange(startDate, undefined, {
      locale,
      year: 'numeric',
      month: 'short',
    });
  }

  if (endDate) {
    return formatDateRange(undefined, endDate, {
      locale,
      year: 'numeric',
      month: 'short',
    });
  }

  return null;
}
